import { render, staticRenderFns } from "./ActivityFile.vue?vue&type=template&id=043b19ef&"
import script from "./ActivityFile.vue?vue&type=script&lang=js&"
export * from "./ActivityFile.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports